var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTether01 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#53AE94;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,8c133.6,0,242,108.4,242,242S383.6,492,250,492S8,383.7,8,250S116.3,8,250,8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.9,217.8v-36h82.3v-54.9H138v54.9h82.3v36c-66.9,3.1-117.2,16.3-117.2,32.2s50.3,29.1,117.2,32.2v115.3 h59.5V282.1c66.8-3.1,117-16.3,117-32.2S346.7,220.8,279.9,217.8 M279.9,272.4L279.9,272.4c-1.7,0.1-10.3,0.6-29.5,0.6 c-15.4,0-26.2-0.4-30-0.6v0c-59.1-2.6-103.2-12.9-103.2-25.2s44.1-22.6,103.2-25.2v40.2c3.9,0.3,14.9,0.9,30.2,0.9 c18.4,0,27.6-0.8,29.3-0.9v-40.2c59,2.6,103,12.9,103,25.2S338.9,269.7,279.9,272.4"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTether01);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TETHER-01.5dbe27ec398896ebe750bfeaa2e92028.svg";